import PropertyScoreColor from './PropertyScoreColour.svg';
import PropertyScoreDark from './PropertyScoreDark.svg';
import PropertyScoreLight from './PropertyScoreLight.svg';
export const propertyScore = { color: PropertyScoreColor, dark: PropertyScoreDark, light: PropertyScoreLight };
//# sourceMappingURL=index.js.map